<ng-container [class.filter-active]="isFilterOpen">
  <mat-form-field class="selecter">
    <mat-select
      [(ngModel)]="selectedOptionId"
      [placeholder]="placeholder"
      class="custom-mat-select"
    >
      @for (question of questions; track question) {
        <div>
          <mat-option
            class="custom-mat-option"
            [ngClass]="{ selected: selectedOptionId === getID(question) }"
            (click)="getQuestionId(getID(question))"
            [value]="getID(question)"
          >
            <div class="question-container">
              <div class="question">
                {{ getStatement(question) }}
              </div>
              @if (selectedOptionId === getID(question)) {
                <div class="question-icon">
                  <img src="../../../assets/images/icon/check-ic.svg" />
                </div>
              }
            </div>
          </mat-option>
        </div>
      }
    </mat-select>
    <img
      style="margin: -2rem"
      matSuffix
      src="../../../assets/images/icon/single-dropdown-arrow.svg"
    />
  </mat-form-field>
</ng-container>
